import '@firebase/database';
//# sourceMappingURL=index.esm.js.map
